import { getFileNameExcel } from "helpers/utils";
import { TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import React from "react";
import ListExport from "./ListExport";

const ListExportTaxDeduct = props => {
  return (
    <ListExport
      typeReport={TYPE_REPORT.TAX_DEDUCT_EXPORT}
      fileNameExport={getFileNameExcel("DanhSachChungTu")}
    />
  );
};

export default ListExportTaxDeduct;
